import React from 'react';
import { Button, LayoutBox } from '@bamboohr/fabric';
import { isEnabled } from '@bamboohr/utils/lib/feature';
import { LoginForm } from '../login-form.react';
import { LoginPassword } from '../../../../login/login/LoginInputs/PasswordInput/login-password'
import {
    bem,
    HEADER,
    PASSWORD_INSTRUCTION,
} from '../../constants';

export function PasswordLoginForm(props) {
    const { primaryAction } = props;
    return (
        <LoginForm
            headerText={HEADER}
            instructionText={PASSWORD_INSTRUCTION}
            {...props}
        >
            <div className={`fieldWrap fab-InputWrapper ${bem.elem('passwordInput')}`}>
                <LoginPassword inputId={'p1'} showForgotPassword={false}/>
            </div>
            {isEnabled('PASSKEYS') && (
                <LayoutBox marginTop={4}>
                    <Button onClick={() => primaryAction()} width={9}>{$.__('Log In')}</Button>
                </LayoutBox>
            )}
        </LoginForm>
    );
}
